import { useAppSelector } from '@frontend/common';
import { SelectOption } from '@frontend/components/basic-forms';
import { EquipmentEnumClient } from '@frontend/equipment/api';
import { EquipmentAction, EquipmentActionName } from '@frontend/equipment/types';
import { fetchGeneralWorkflowActions, workflowSharedStore } from '@frontend/workflow/redux';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { EquipmentActionSelectProps } from './equipment-action-select.component';

interface ViewProps {
    options: SelectOption<EquipmentActionName>[];
}

const useProductActionSelect = (props: EquipmentActionSelectProps): ViewProps => {
    const [actions, changeActions] = useState<string[]>([]);
    const workflowSharedState = useAppSelector(useSelector, workflowSharedStore);

    useEffect(() => {
        props.dispatch && props.dispatch(fetchGeneralWorkflowActions());
        EquipmentEnumClient.fetchEquipmentActions().then(changeActions);
    }, []);

    const options = useMemo(() => {
        if (!actions || !workflowSharedState.generalWorkflowActions) return [];
        return [...actions, ...workflowSharedState.generalWorkflowActions].map((action) => {
            const found = EquipmentAction.ALL.find((t) => t.value.toString() === action);
            if (found) return { value: found.value.toString(), label: found.value, display: found.displayName };
            else
                return {
                    value: action,
                    label: action.replace(/_/g, ' ')
                };
        });
    }, [actions, workflowSharedState.generalWorkflowActions]);

    return { options };
};

export default useProductActionSelect;
